import "react-toastify/dist/ReactToastify.css";
import { http_api } from "../../leadg-api";
const getAllAdminUsers = (isActive) => {
    if (isActive === null) {
        return http_api.get(`users/get-admin-users`);
    }
    return http_api.get(`users/get-admin-users?isActive=${isActive}`);
};
// Users eligible as a "responsible person" (verantwoordelijke) — server returns only
// users in the Sales Agent role (or all users if that role isn't found). Same DTO shape
// as getAllAdminUsers so callers are interchangeable.
const getResponsiblePersons = (isActive) => {
    if (isActive === null) {
        return http_api.get(`users/get-responsible-persons`);
    }
    return http_api.get(`users/get-responsible-persons?isActive=${isActive}`);
};
const getRolesOptions = () => {
    return http_api.get(`role/get-all-role-for-user`);
};
const createAdminUser = (input) => {
    return http_api.post("users/register-admin", input);
};
const getAdminUserById = (id) => {
    return http_api.get(`users/get-user-by_id/${id}`);
};
const updateAdminUser = (input) => {
    return http_api.put("users/upadate-admin-user", input);
};
const deleteUserById = (input) => {
    return http_api.post(`users/delete-admin-user`, input);
};
const ActivateUserById = (input) => {
    return http_api.put(`users/active-admin-user`, input);
};
const updateUserLocale = (request) => {
    return http_api.post("users/update-user-locale", request);
};
// Self-edit for the currently logged-in user's own Initials (Item #1). No id
// is sent — the backend resolves the target user from the auth token.
const updateOwnInitials = (request) => {
    return http_api.put("users/update-own-initials", request);
};
const UsersApi = {
    getAllAdminUsers,
    getResponsiblePersons,
    createAdminUser,
    getAdminUserById,
    updateAdminUser,
    deleteUserById,
    getRolesOptions,
    ActivateUserById,
    updateUserLocale,
    updateOwnInitials,
};
export default UsersApi;
